// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trustpilot-head,
p.text-sm {
  color: #52585f;
}

.trustpilot__container {
  gap: 28px;
  column-count: 3;
  column-gap: 28px;
}
@media only screen and (max-width: 1199px) {
  .trustpilot__container {
    column-count: 1;
  }
}
.trustpilot__container > * {
  break-inside: avoid;
}
.trustpilot__container > * .h3 {
  color: #211f54;
  margin-bottom: 8px;
  font-weight: 700;
  line-height: 1.417em;
}
.trustpilot__container > * p.text-sm {
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/trustpilot/trustpilot.component.scss"],"names":[],"mappings":"AAMA;;EAEE,cAAA;AALF;;AAQA;EACE,SAAA;EAGA,eAAA;EAGA,gBAAA;AALF;AAZE;EAUF;IAYI,eAAA;EAJF;AACF;AAME;EACE,mBAAA;AAJJ;AAMI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAJN;AAOI;EACE,iBAAA;AALN","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.trustpilot-head,\r\np.text-sm {\r\n  color: #52585f;\r\n}\r\n\r\n.trustpilot__container {\r\n  gap: 28px;\r\n  -webkit-column-count: 3;\r\n  -moz-column-count: 3;\r\n  column-count: 3;\r\n  -webkit-column-gap: 28px;\r\n  -moz-column-gap: 28px;\r\n  column-gap: 28px;\r\n\r\n  @include md() {\r\n    -webkit-column-count: 1;\r\n    -moz-column-count: 1;\r\n    column-count: 1;\r\n  }\r\n\r\n  > * {\r\n    break-inside: avoid;\r\n\r\n    .h3 {\r\n      color: #211f54;\r\n      margin-bottom: 8px;\r\n      font-weight: 700;\r\n      line-height: 1.417em;\r\n    }\r\n\r\n    p.text-sm {\r\n      line-height: 24px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
